import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { c as o } from "../../index-C7ezJk5b.js";
import "../../base-BUIxijjU.js";
import "react";
import { capitalize as i } from "../../core/utils/string.js";
import { cssX as a, cssTI as p } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const _ = ({
  children: r,
  testId: t
}) => /* @__PURE__ */ e(
  "div",
  {
    className: o(a("GlobalSearchGroup__footer")),
    "data-testid": t,
    children: r
  }
), v = ({
  title: r,
  children: t,
  className: l,
  isCol: s
}) => /* @__PURE__ */ c("div", { className: o(a("GlobalSearchGroup"), l), children: [
  /* @__PURE__ */ e(
    "div",
    {
      className: o(a("GlobalSearchGroup__title")),
      "data-testid": p("label", `SearchPopupGroupTitle${i(r, !0)}`),
      children: r
    }
  ),
  /* @__PURE__ */ e("div", { className: o(
    a("GlobalSearchGroup__body"),
    s && "is-col"
  ), children: t })
] });
export {
  _ as GlobalSearchResultsCardFooter,
  v as default
};
